<template>
    <div>
        <b-form>
            <b-row class="mt-3">
                <b-col v-if="isEditMode">
                    <b-form-group label="Número do Contrato:" label-for="numeroContrato">
                        <b-form-input style="height: 20px;" id="numeroContrato" v-model="contratoForm.numeroContrato" disabled />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Número da Licitação: *" label-for="situacaoContrato">
                        <b-form-input style="height: 20px;" v-model="contratoForm.numeroLicitacao" required>
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group class="ml-3" label="Renovável:" label-for="renovavel">
                        <b-form-checkbox id="renovavel" v-model="contratoForm.renovavel" switch :value="1"
                            :unchecked-value="0">
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <lg-form-select v-model="contratoForm.tipoRequisicaoCompra" @input="setTipoRequisicaoCompra"
                        :loadFunction="listTipos" labelFormGroupBind="Tipo de Compra:*" label="descricao"
                        description="" />
                </b-col>
                <b-col cols="12" md="6"
                    v-if="contratoForm.tipoRequisicaoCompraId == tipoRequisicaoCompraEnum.LICITACAO.cod">
                    <LgFinderPageModalidadeContrato title="Modalidade de Licitação" :prefix="prefix"
                        v-model="contratoForm.modalidadeContrato" label="Modalidade de Licitação:*"
                        @input="setModalidadeContrato"
                        :tipoContratoId="contratoForm.tipoContrato ? contratoForm.tipoContrato.cod : null" />
                </b-col>

                <b-col cols="12" md="6">
                    <LgFinderPageTipoContrato :prefix="prefix" v-model="contratoForm.tipoContrato"
                        label="Tipo de Contrato:*" @input="setTipoContrato" />
                </b-col>
                <b-col cols="12" md="6">
                    <LgFinderPageGrupoContrato :prefix="prefix" v-model="contratoForm.grupoContrato"
                        label="Categoria de Contrato:*" title="Categoria de Contrato" @input="setGrupoContrato" />
                </b-col>
                <b-col cols="12" md="6">
                    <LgFinderPageGarantiaContrato :prefix="prefix" v-model="contratoForm.garantiaContrato"
                        label="Garantia Contrato:" @close="setGarantiaContrato" />
                </b-col>

                <b-col cols="12" md="6">
                    <LgFormDate label="Data de Assinatura:*" description='' v-model="contratoForm.dataAssinatura"
                        required />
                </b-col>

                <b-col cols="12" md="6">
                    <LgFormDate label="Data limite por cláusula de vigência:*" description=''
                        v-model="contratoForm.dataLimite" required />
                </b-col>

                <b-col cols="12" md="6">
                    <LgFormDate label="Data de Proposta:*" description='' v-model="contratoForm.dataProposta"
                        required />

                </b-col>
                <b-col cols="12" md="6">
                    <LgFormDate label="Data de Publicação:*" description='' v-model="contratoForm.dataPublicacao"
                        required />

                </b-col>

                <b-col cols="12" md="6">
                    <LgFinderPageUnidadeAdministrativa v-model="contratoForm.unidadeAdministrativa"
                        label="Unidade Administrativa:*" @onselect="setUnidadeAdministrativa" />
                </b-col>
                <b-col cols="6">
                    <LgFinderPageContrato :processoCompra="processoCompra" @input="handleContratoAntecessor"
                        :label="'Contrato Antecessor:'" v-model="contratoForm.contratoAntecessor" :prefix="prefix"
                        :id="'contratoAntecessor' + idFinderContrato" />
                </b-col>
                <b-col cols="6">
                    <LgFinderPageContrato :processoCompra="processoCompra" @input="handleContratoSucessor"
                        :label="'Contrato Sucessor:'" v-model="contratoForm.contratoSucessor" :prefix="prefix"
                        :id="'ContratoSucessor' + idFinderContrato" />
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Processo:*" label-for="processo">
                        <b-form-input :disabled="processoCompra != null" id="processo" style="height: 20px;"
                            v-model="contratoForm.processo" required />
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group label="Situação Contrato:" label-for="situacaoContrato">
                        <b-form-input style="height: 20px;" v-model="contratoForm.situacaoContrato"
                            id="situacaoContrato" disabled>
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Foro:*" label-for="foro">
                        <b-form-textarea id="foro" v-model="contratoForm.foro" required />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Objeto Resumido:*" label-for="resumo">
                        <b-form-textarea id="resumo" v-model="contratoForm.resumo" required />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Objeto Detalhado:*" label-for="objetoDetalhado">
                        <b-form-textarea id="objetoDetalhado" v-model="contratoForm.objetoDetalhado" required />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script>
import LgFinderPageTipoContrato from "@/components/Finders/LgFinderPageTipoContrato.vue";
import LgFinderPageModalidadeContrato from "@/components/Finders/LgFinderPageModalidadeContrato.vue";
import LgFinderPageGrupoContrato from "@/components/Finders/LgFinderPageGrupoContrato.vue";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import ResourceService from "@/core/api/ResourceService";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"
import TipoRequisicaoCompraEnum from "@/core/utils/TipoRequisicaoCompraEnum";
import LgFinderPageContrato from "@/components/Finders/LgFinderPageContrato.vue";
import LgFinderPageGarantiaContrato from "@/components/Finders/LgFinderPageGarantiaContrato.vue";

export default {
    name: "ContratoForm",
    components: {
        LgFinderPageGarantiaContrato,
        LgFinderPageContrato,
        LgFormSelect,
        LgFinderPageTipoContrato,
        LgFinderPageModalidadeContrato,
        LgFinderPageGrupoContrato,
        LgFinderPageUnidadeAdministrativa,
        LgFormDate
    },
    props: {
        idFinderContrato: {
            type: String,
            default: ''
        },

        processoCompra: {
            type: Object,
            default: null
        },
        prefix: {
            type: String,
            default: ""
        },
        contratoFormParam: {
            type: Object,
            required: true,
        },
        isEditMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tipoRequisicaoCompraEnum: TipoRequisicaoCompraEnum,
            contratoForm: this.contratoFormParam,
        };
    },
    beforeMount() {
        if (this.processoCompra != null) {
            this.contratoForm.processo = this.processoCompra.numeroProcesso;
        }
    },
    methods: {
        setGarantiaContrato(item) {
            this.contratoForm.garantiaContrato = item;
        },
        handleContratoAntecessor(item) {
            this.contratoForm.contratoAntecessor = item;
        },

        handleContratoSucessor(item) {
            this.contratoForm.contratoSucessor = item;
        },
        async listTipos({ filter, page = 1 }) {
            return new ResourceService(`/api/tipo-requisicao-compra`).findAll({ filter, page, limit: 5 })
        },

        setTipoContrato(item) {
            this.contratoForm.tipoContrato = item;
            this.contratoForm.tipoContratoId = item ? item.cod : null;
        },
        setModalidadeContrato(item) {
            this.contratoForm.modalidadeContrato = item;
            this.contratoForm.modalidadeContratoId = item ? item.cod : null;
        },
        setGrupoContrato(item) {
            this.contratoForm.grupoContrato = item;
            this.contratoForm.grupoContratoId = item ? item.cod : null;
        },
        setTipoRequisicaoCompra(item) {
            this.contratoForm.tipoRequisicaoCompra = item;
            this.contratoForm.tipoRequisicaoCompraId = item ? item.id : null;
        },
        setUnidadeAdministrativa(item) {
            this.contratoForm.unidadeAdministrativa = item;
            this.contratoForm.unidadeAdministrativaId = item ? item.id : null;
        },
    },
};
</script>

<style scoped></style>
